// this can be deleted once ProjectedWithLegend-legacy is removed and upcoming feature flag is on ^^

// the select on the projected cash flow is 2 weeks, 1 month, 2 months, etc this standardizes it instead of using
// hard coded amount of days which leads to very weird cases when you do longer ranges such as Jan 12 - April 10, for 3 months
export const DATE_RANGES = {
  fourteen: { weeks: 2 },
  thirty: { months: 1 },
  sixty: { months: 2 },
  ninety: { months: 3 },
  oneEighty: { months: 6 },
  threeSixtyFive: { year: 1 },
};

export const projectedBalancesId = 'projected-balances-root';
